<template>
  <label class="l-radio">
    <span class="l-radio flex">
      <input
        :id="`l-radio-${_uid}`"
        type="radio"
        :name="name"
        :checked="isChecked"
        :value="value"
        @change="onChange"
      >
    </span>
    <svg
      v-if="!isChecked"
      class="svg-inline--fa fa-circle fa-w-16 l-radio__inner"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
      ></path>
    </svg>
    <svg
      v-if="isChecked"
      class="svg-inline--fa fa-dot-circle fa-w-16 l-radio__inner l-radio__inner--checked"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      ></path>
    </svg>
    <span class="l-radio__label">
      <span v-if="label">{{ label }}</span>
      <slot v-else/>
    </span>
  </label>
</template>

<script>
export default {
  name: "LRadio",

  model: {
    prop: "modelValue",
    event: "change"
  },

  props: {
    modelValue: {},
    value: [String, Number],
    label: String,
    type: String,
    name: String
  },

  computed: {
    isChecked() {
      return this.modelValue === this.value;
    }
  },
  methods: {
    onChange() {
      return this.$emit("change", this.value);
    }
  }
};
</script>

<style lang="postcss">
.l-radio {
  @apply cursor-pointer;
  @apply text-xs text-pastel-black;
  display: inline-table;
}

.l-radio__label {
  @apply leading-tight;
}

.l-radio__inner {
  @apply text-sm text-gray-500 mr-1;
}
.l-radio__inner--checked {
  @apply text-pastel-green-500;
}

.l-radio input {
  display: none;
}
</style>
